import React, {useEffect, useState} from "react";
import makeStyles from "@mui/styles/makeStyles";
import Navigation from "./navigation";
import {CloudDownloadOutlined, OpenInNew} from "@mui/icons-material";

let vh = window.innerHeight * 0.01;

const useStyles = makeStyles({
  scrollable: {
    ['@media (max-width: 640px)']: {
      overflowY: 'scroll',
      minHeight: 100*vh-68,
      display: 'flex',
      flexDirection: 'column',
      // justifyContent: 'center',
      alignItems: 'center',
      textAlign: 'center',
    },
    ['@media (min-width: 640px)']: {
      overflowY: 'scroll',
      minHeight: 720-68,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      textAlign: 'center',
    },
  },
  main: {
    position: 'relative',
    background: 'linear-gradient(180.02deg, #FF8A00 0.02%, #58AF56 121.49%, #58AF56 184.83%)',
    height: 'inherit',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    boxSizing: 'inherit',
    borderRadius: 'inherit',
    margin: 0,
  },
  image: {
    margin: '12px',
    maxHeight: '100px',
    maxWidth: '75px',
    height: '20%',
    width: '15%',
  },
  textHeader: {
    fontStyle: 'normal',
    fontSize: '22px',
    fontWeight: 'bold',
    lineHeight: '30px',
    textAlign: 'center',
    margin: '40px',
    color: '#000000',
    ['@media (max-width: 400px)']: {
      fontSize: '20px',
      lineHeight: '22px',
    },
  },
  instructionRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    maxWidth: '800px',
    marginBottom: '50px',
  },
  textNumber: {
    fontStyle: 'bold',
    fontSize: '18px',
    lineHeight: '24px',
    color: '#000000',
    marginRight: '20px',
  },
  textInstruction: {
    fontStyle: 'normal',
    fontSize: '18px',
    lineHeight: '24px',
    textAlign: 'left',
    color: '#000000',
    width: '60%',
    marginRight: '16px',
    ['@media (max-width: 400px)']: {
      fontSize: '16px',
      lineHeight: '20px',
    },
  },
  textCentered: {
    fontStyle: 'normal',
    fontSize: '14px',
    lineHeight: '18px',
    textAlign: 'center',
    color: '#000000',
    width: '70%',
    marginLeft: '15%',
    marginRight: '15%',
  },
  divider: {
    align: 'center',
    background: '#000000',
    border: "3px solid #000000",
    boxSizing: "border-box",
    borderRadius: '3px',
    marginBottom: '45px',
    marginLeft: '30%',
    marginRight: '30%',
    width: '40%',
  },
  linkToShare: {
    flex: '0 1 auto',
    bottom: 0,
    width: '90%',
    marginLeft: '5%',
    marginRight: '5%',
    marginTop: '20px',
    marginBottom: '20px',
    boxSizing: "border-box",
    borderRadius: '10px',
    boxShadow: '5px 5px 5px 5px rgb(0 0 0 / 0.2)',
    maxWidth: 'inherit',
    height: 'fit-content',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    background: '#E8E8E8',
    ['@media (min-width: 640px)']: {
          width: '400px',
          height: '90%',
          marginTop: '20px',
          marginBottom: '20px',
          marginLeft: '120px',
          marginRight: '120px',
          // border: "1px solid #000000",
          boxSizing: "border-box",
          borderRadius: '20px',
          boxShadow: '5px 5px 5px 5px rgb(0 0 0 / 0.2)',
      }
  },
});

export default function Reward() {
  const classes = useStyles();
  const [facts, setFacts] = useState([]);
  const [linkCopied, setLinkCopied] = useState(false);

  const handleLink = () => {
    setLinkCopied(true);
    navigator.clipboard.writeText('https://e.org.pl/quiz-klimatyczny/');
  }

    useEffect(() => {
    if (linkCopied) {
      document.getElementsByClassName(classes.scrollable)[0].scrollTo({
        top: document.getElementsByClassName(classes.scrollable)[0].scrollHeight,
        left: 0,
        behavior: 'smooth',
      });
    }
  }, [linkCopied])


  useEffect(() => {
    fetch("/quiz-klimatyczny/fakty.json").then((response) => response.json()).then(setFacts);
  })

  return (
    <main className={classes.main} id='reward'>
      <div className={classes.scrollable}>
        <h2 className={classes.textHeader}>Pięć najważniejszych faktów o zmianach klimatu</h2>
        <div className={classes.divider}/>
        {facts.map(({fact, link}, number) => (
          <div className={classes.instructionRow}>
          <img src={'noun-heat-wave-3189081 2.svg'} className={classes.image}/>
            <div className={classes.textNumber}><p>{number+1}.</p></div>
          <div className={classes.textInstruction}>
            <p>
              {fact}
            </p>
            <a href={link} style={{textDecoration: 'none', color: 'white', display: 'flex'}} target={'_blank'}><OpenInNew style={{marginRight: '5px'}}/><div style={{display: 'inline'}}>DOWIEDZ SIĘ WIĘCEJ</div></a>
          </div>
        </div>
        ))}
        <h2 className={classes.textHeader}>Interesuje Cię temat zmiany klimatu?</h2>
        <div className={classes.divider} style={{marginBottom: '20px'}}/>
        <a href={'https://wuw.pl/data/include/cms//Klimatyczne_ABC_Budziszewska_M_Kardas_A_Bohdanowicz_Z_red_2021.pdf?v=1625481918966'} style={{textDecoration: 'none', color: 'white', display: 'flex'}} target={'_blank'}><p className={classes.textHeader} style={{marginBottom: 0, color: 'white'}}>DOWIEDZ SIĘ WIĘCEJ Z PUBLIKACJI KLIMATYCZNE ABC</p></a>
        <img src={'logo_SwS_podstawowe 2.svg'} style={{align: "center", marginTop: "80px"}}/>
        <p className={classes.textCentered}>Quiz powstał w ramach projektu „Seniorzy w sieci” jako część programu “Countering Disinformation among Vulnerable Populations in Central Europe” realizowanego w 4 krajach: Polska (Towarzystwo Inicjatyw Twórczych “ę”), Czechy (Transitions), Słowacja (Memo98), Węgry (Center of Independent Journalism).</p>
        <p className={classes.textCentered}>Projekt jest współfinansowany ze środków otrzymanych od Ministra Rodziny i Polityki Społecznej w ramach programu wieloletniego na rzecz Osób Starszych „Aktywni+” na lata 2021–2025 Edycja 2021.</p>
        <h2 className={classes.textHeader} style={{marginBottom: '15px', marginTop: '15px'}}>Organizator:</h2>
        <img src={'LOGOe_poziome_czarne 2.svg'} style={{align: "center"}}/>
        <h2 className={classes.textHeader} style={{marginBottom: '15px', marginTop: '15px'}}>Partnerzy:</h2>
        <div className={classes.instructionRow} style={{marginBottom: 0}}>
          <img src={'TOL 2 - Logo - CLR1.svg'} style={{align: "center"}}/>
          <img src={'Demagog 2.svg'} style={{align: "center"}}/>
          <img src={'Logotyp transparentny 2.svg'} style={{align: "center"}}/>
        </div>
        <h2 className={classes.textHeader} style={{marginBottom: '15px', marginTop: '15px'}}>Współfinansowanie:</h2>
        <img src={'Aktywni+_logo.svg'} style={{align: "center", marginBottom: '40px'}}/>
        {linkCopied && <div className={classes.linkToShare}>
          <p className={classes.textCentered} style={{fontSize: '24px'}}>
            Skopiowano link do quizu
          </p>
        </div>}
      </div>
      <Navigation buttonHandler={handleLink} buttonText={'poleć quiz'} isGreen={true}/>
    </main>
  );
}